import { ReactComponent as Android } from "../../../../../../assets/images/imgly/android.svg";
import { ReactComponent as Apple } from "../../../../../../assets/images/imgly/apple.svg";
import * as React from 'react';
export default {
  Android,
  Apple,
  React
};